
import { create } from "zustand";

interface UnderwriterClaimDetails {
  claimId: string;
  claimStatus: string;
  assignedTo: string;
  policyResponseDto: any;
  claimantResponseDto: any;
  deceasedResponseDto: any;
  bankingInfoResponseDto: any;
  benefitSelections: any;
  documentResponseDtoList: any[];
  commentResponseDtoList: any[];
}

interface UnderwriterStore {
  underwriterClaimDetails: UnderwriterClaimDetails | null;
  setUnderwriterClaimDetails: (data: UnderwriterClaimDetails) => void;
  clearUnderwriterClaimDetails: () => void;
}

export const useUnderwriterClaimDeatilsStore = create<UnderwriterStore>(
  (set) => ({
    underwriterClaimDetails: null,
    setUnderwriterClaimDetails: (data) =>
      set({ underwriterClaimDetails: data }),
    clearUnderwriterClaimDetails: () => set({ underwriterClaimDetails: null }),
  })
);
